import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-agent-management-report',
  templateUrl: './agent-management-report.component.html',
  styleUrls: ['./agent-management-report.component.css']
})
export class AgentManagementReportComponent extends BaseCrudComponent {

    translations:any;
    header:any;
    momentjs: any = moment;
    curr_date:any;
    dstart:any;
    dend:any;
    zones:any;
    theaders:any;

    offline_date = '';
    zoom = 15;
    track_lat:any;
    track_lng:any;

    exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
      ) {
          super(srv, modalService, storage, router);
          this.read_url = 'Portal/AgentManagement';
          this.header = {};
          this.zones = [];

          this.theaders = [
              { field: 'agentName', header: 'Agente', sortable:true, sortfield:'agentName', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'visitDate', header: 'Día Visita', sortable:true, sortfield:'visitDate', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'beginManagement', header: 'Inicio Gestión', sortable:true, sortfield:'beginManagement', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'endManagement', header: 'Fin Gestión', sortable:true, sortfield:'endManagement', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'clientsInRoute', header: 'Clientes en Ruta', sortable:true, sortfield:'clientsInRoute', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'clientsOutOfRoute', header: 'Clientes Fuera Ruta', sortable:true, sortfield:'clientsOutOfRoute', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'faceToFace', header: 'Visita Presencial', sortable:false, sortfield:'faceToFace', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'ordersQuantity', header: 'No. Pedido Generado', sortable:false, sortfield:'ordersQuantity', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'ordersTotal', header: 'Monto Pedido', sortable:false, sortfield:'ordersTotal', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'collectQuantity', header: 'No. Cobro Generado', sortable:false, sortfield:'collectQuantity', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
              { field: 'collectTotal', header: 'Monto Cobro', sortable:false, sortfield:'collectTotal', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:''},
          ];
      }

    ngOnInit() {
        this.dstart = this.momentjs().tz('America/Guayaquil');
        this.dstart.day(1);
        //this.f_datefrom = this.dstart.format('YYYY-MM-DD');
        this.f_datefrom = {year:this.dstart.year(), month:this.dstart.month()+1, day:this.dstart.date()};

        this.dend = this.momentjs().tz('America/Guayaquil');
        this.dend.day(5);
        //this.f_dateto = this.dend.format('YYYY-MM-DD');
        this.f_dateto = {year:this.dend.year(), month:this.dend.month()+1, day:this.dend.date()};

        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.curr_date = this.momentjs().tz('America/Guayaquil');

        this.translate.getTranslation(this.translate.currentLang)
          .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
          });
    }

    public getList(){
        var qst = this.read_url;
        var to:any;

        this.rows = [];

        var start = this.momentjs(this.getISODate(this.f_datefrom));
        var end = this.momentjs(this.getISODate(this.f_dateto));
        
        if( end.isBefore(start) ){
            //Swal.fire('Fecha Hasta debe ser mayor a Fecha Desde', '', 'error');
            Swal.fire('Fecha Hasta debe ser mayor o igual a Fecha Desde', '', 'error');
            return;
        }

        to = {
            // startDate: '2022-11-01',
            // endDate: '2022-11-30',
            startDate: this.getISODate(this.f_datefrom),
            endDate: this.getISODate(this.f_dateto)
        };

        this.loadingList = true;
        this.srv.postCall(qst, to).subscribe(x => {
            this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.rawdata = rs;
                this.rows = this.rawdata;
            }
        });
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'gestion_agentes_'+this.curr_date).subscribe(() => {
          // save started
        });
    }

}
